module.exports = __webpack_public_path__ + "img/daigiadataha.f902c1f6.png";